import { render, staticRenderFns } from "./PublishRepeatList.vue?vue&type=template&id=88940c24&scoped=true"
import script from "./PublishRepeatList.vue?vue&type=script&lang=js"
export * from "./PublishRepeatList.vue?vue&type=script&lang=js"
import style0 from "./PublishRepeatList.vue?vue&type=style&index=0&id=88940c24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88940c24",
  null
  
)

export default component.exports